module.exports = __webpack_public_path__ + "img/hp-leftarrow.7a0313b8.svg";